import { createFileRoute } from "@tanstack/react-router";

import { MirrorPage } from "@/components/MirrorPage";
import { content } from "@/mirror/page/privacy";
import { requireUnlockedHome } from "@/lib/gate.functions";
import { mirrorHead } from "@/mirror/pages";

export const Route = createFileRoute("/privacy/")({
  loader: () => requireUnlockedHome(),
  head: () => mirrorHead("privacy"),
  component: () => <MirrorPage key="privacy" slug="privacy" content={content} />,
});
